import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, FormBuilder, Validators} from '@angular/forms';
import {ActivatedRoute, Router, ParamMap} from '@angular/router';
import {CoreService} from '../../helper/core/core.service';
import {registerLocaleData} from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import {Constant} from '../../helper/core/constant';
import {BuNameService} from '../../helper/core/bu-name.service';
import {UserService} from '../../helper/core/user.service';
import {UtilsService} from '../../helper/utils/utils.service';
import {element} from "protractor";
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {

  public idSlot: string = "";
  public event: any = false;
  public errorMsg: string = "";
  public errorApi: boolean = false;
  public cgu: string;
  public timezone: string;
  public invite:number = 0;
  public inviteMax: number = 4;

  showAgeField: boolean = false;
  requireds: any[];
  registerLastname: FormControl;
  registerFirstname: FormControl;
  registerEmail: FormControl;
  registerTelephone: FormControl;
  registerTelephoneFixe: FormControl;
  registerAge: FormControl;
  registerAdresse: FormControl;
  registerCp: FormControl;
  registerCoutry: FormControl;
  registerVille: FormControl;
  registerCgu: FormControl;
  registerForm: FormGroup;

  constructor(private builder: FormBuilder,
              private route: ActivatedRoute,
              private coreService: CoreService,
              private router: Router,
              private constant: Constant,
              private buNameService: BuNameService,
              private userService: UserService,
              private utils: UtilsService) {
  }

  ngOnInit() {

    // Destroy tooltip : Fix graphic bug
    $('.tooltip').remove();

    // Gestion du format de date
    registerLocaleData(localeFr, 'fr');

    // Validator du champ nom
    this.registerLastname = new FormControl('', [
      Validators.required,
      Validators.pattern(this.constant.namePattern)
    ]);
    // Validator du champ prénom
    this.registerFirstname = new FormControl('', [
      Validators.required,
      Validators.pattern(this.constant.namePattern)
    ]);
    // Validator du champ email
    this.registerEmail = new FormControl('', [
      Validators.required,
      Validators.pattern(this.constant.emailPattern)
    ]);
    // Validator du champ téléphone
    this.registerTelephone = new FormControl('', [
      Validators.required,
      Validators.pattern(this.constant.mobilePattern)
    ]);
    // Validator du champ téléphone
    this.registerTelephoneFixe = new FormControl('', [
      Validators.pattern(this.constant.fixePattern)
    ]);
    // Validator du champ adresse
    this.registerAdresse = new FormControl('', []);
    // Validator du champ code postale
    this.registerCp = new FormControl('', [
      Validators.required,
      Validators.minLength(5),
      Validators.maxLength(5),
      Validators.pattern(this.constant.postalCodePattern)
    ]);
    // Validator du champ ville
    this.registerVille = new FormControl('', []);
    // Validator du champ CGU
    this.registerCgu = new FormControl('', [
      // Validators.required
    ]);
    
    // Validator du champs pays !! honeypot !!!!
    this.registerCoutry = new FormControl("", [
      Validators.maxLength(0),
    ]);
    // Enregistrement du formulaire
    this.registerForm = this.builder.group({
      lastname: this.registerLastname,
      firstname: this.registerFirstname,
      email: this.registerEmail,
      telephone: this.registerTelephone,
      country: this.registerCoutry,
      telephoneFixe: this.registerTelephoneFixe,
      address: this.registerAdresse,
      postalCode: this.registerCp,
      city: this.registerVille,
      notParticipate: false,
      cgu: this.registerCgu
    });


    // On récupère l'id du Slot
    this.route
      .queryParamMap
      .subscribe((params: ParamMap) => {
        this.idSlot = params.get('id');

        if (this.idSlot == null) {
          // On redirige vers la page événement si pas d'id dans l'url
          let buSlug = this.route.snapshot.paramMap.get('bu');
          let eventSlug = this.route.snapshot.paramMap.get('event');
          this.router.navigate(['/' + buSlug + '/' + eventSlug]);
        }
        else {
          this.getSlotInformation(this.idSlot);
        }
      });

  }

  async onSubmit() {
    if (this.registerForm.valid) {
      // On request pour s'enregistrer
      let obj:any = {
        firstName: this.registerForm.value.firstname,
        lastName: this.registerForm.value.lastname,
        email: this.registerForm.value.email,
        phone: this.registerForm.value.telephone,
        fixePhone: this.registerForm.value.telephoneFixe,
        address: this.registerForm.value.address,
        postalCode: this.registerForm.value.postalCode,
        city: this.registerForm.value.city,
        required: '',
        cgu: this.registerForm.value.registerCgu
      };



      const requiredVals = {};
      if (!Object.entries) {
        Object.entries = function(obj) {
          const ownProps = Object.keys( obj );
          let i = ownProps.length;
          const resArray = new Array(i);
          while (i--) {
            resArray[i] = [ownProps[i], obj[ownProps[i]]];
          }
          return resArray;
        };
      }
      for (const [key, val] of Object.entries(this.registerForm.value)) {
        if (key.indexOf('required-') !== -1) {
          requiredVals[key.replace('required-', '')] = val;
        }
      }

      obj.required = JSON.stringify(requiredVals);

      if (this.invite) {
        obj.invite = new Array();

        for (let i = 0; i < this.invite; i++) {
          obj.invite.push({
            "lastName": this.registerForm.value["invite-lastname-"+i],
            "firstName":this.registerForm.value["invite-firstname-"+i],
            "email": this.registerForm.value["invite-email-"+i],
            "phone": this.registerForm.value["invite-phone-"+i]
          });
        }
      }

      this.errorMsg = "";
      this.coreService.subscribeToEvent(this.idSlot, obj).subscribe(
        data => {
          // On redirige vers la page confirmation
          const buSlug = this.route.snapshot.paramMap.get('bu');
          const eventSlug = this.route.snapshot.paramMap.get('event');

          utag.link({
            'track_zone' : this.event.buSlug + '_' + this.event.slug + '_coordonnees',
            'track_nom' : 'confirmer_votre_inscription',
            'track_cible' : window.location.origin + '/' + buSlug + '/' + eventSlug + '/' + 'confirm' + '?id=' + this.idSlot + '&user=' + data.idRegistration
          });

          // On enregistre les informations dans le storage
          // data => {email : xxx, idRegistration : xxx}
          this.userService.setUser(data);

          this.router.navigate(['/' + buSlug + '/' + eventSlug + '/confirm'], {
            queryParams: {
              'id': this.idSlot,
              'user': data.idRegistration
            }
          });
        }, dataError => {
          this.errorMsg = dataError;
          this.utils.scrollTo("body");
        }
      );
    }
    else {
      // Déclenche les erreurs
      Object.keys(this.registerForm.controls).forEach(field => {
        const control = this.registerForm.get(field);
        control.markAsTouched({onlySelf: true});
      });
    }
  }

  /**
   * API Récupère les informations
   * de l'évènement par l'id du Slot
   * @param idSlot | String : id du Slot
   */
  private getSlotInformation(idSlot) {
    this.coreService.getSlot(idSlot).subscribe(
      (data) => {
        // Attribution du nom de la BU dans le header
        this.buNameService.name = data.bu_name;
        // Attribution de l'url de la BU dans le header
        this.buNameService.url = data.buSlug;
        // Attribution de l'img de la BU dans le header
        this.buNameService.img = (typeof data.bu_logo != "undefined") ? data.bu_logo : "default";
        // Changement de title du site
        this.buNameService.title = data.name;

        this.inviteMax = data.nbr_invite;

        this.cgu = data.cgu;

        // Attribution des éléments de event
        this.event = data;
        this.timezone = data.currentGmt;

        // On check si on doit afficher le champ age
        this.showAgeField = (data.age_min != undefined);
        // Si oui, on rajoute le controlleur au formulaire
        if (this.showAgeField) {
          // Validator du champ âge
          this.registerAge = new FormControl('', [
            Validators.required,
            Validators.min(data.age_min)
          ]);
          this.registerForm.setControl("age", this.registerAge);
        }

        // On récupère toutes les checkboxes du BO
        this.requireds = new Array();

        if (this.cgu) {
          this.registerCgu = new FormControl(null, [
            // Validators.requiredTrue
          ]);
          this.registerForm.setControl('registerCgu', this.registerCgu);
        }

        // Pour chaque checkboxes, on ajoute son controlleur au formulaire puis on ajoute le champ au front
        if (data && data.opts)
          data.opts.forEach((element) => {

            let controleName: string = 'required-' + element.id;

            let controlForm: FormControl = new FormControl(null, element.required ? [
              Validators.requiredTrue
            ] : null);

            let inputText = element.pdf ?
              "<a href=\"/" + element.pdf + "\" target='_blank'>" + element.text + "</a>"
              : element.text;

            this.requireds.push({'id': element.id, 'text': element.required ? inputText + ' *' : inputText});
            this.registerForm.setControl(controleName, controlForm);
          });
      }, (dataError) => {
        this.errorApi = true;
      });
  }

  private isErrorRequired(i: number) {
    return (!this.registerForm.controls['required-' + i].valid && this.registerForm.controls['required-' + i].touched);
  }

  addInvite():void{
    if(this.invite < this.inviteMax){
      let index = this.invite;
      // Validator du champ nom
      let lastNameFormControl = new FormControl('', [
        Validators.required,
        Validators.pattern(this.constant.namePattern)
      ]);
      // Validator du champ prénom
      let firstNameFormControl = new FormControl('', [
        Validators.required,
        Validators.pattern(this.constant.namePattern)
      ]);
      // Validator du champ email
      let emailFormControl = new FormControl('', [
        Validators.required,
        Validators.pattern(this.constant.emailPattern)
      ]);
      // Validator du champ téléphone
      let phoneFormControl = new FormControl('', [
        Validators.required,
        Validators.pattern(this.constant.mobilePattern)
      ]);
      this.registerForm.addControl("invite-lastname-"+index, lastNameFormControl);
      this.registerForm.addControl("invite-firstname-"+index, firstNameFormControl);
      this.registerForm.addControl("invite-email-"+index, emailFormControl);
      this.registerForm.addControl("invite-phone-"+index, phoneFormControl);

      this.invite++;
    }
  }

  removeInvite(index:number):void{
    // Cas simple où l'on suppr le dernier formulaire
    if(index+1 == this.invite){
      this.invite = (this.invite > 0) ? --this.invite : 0;
      this.removeInviteControl(index);
    }
    // Sinon
    // On remplace les valeurs des champs avec les valeurs de la personnes suivantes
    // On suppr le dernier formulaire
    else{
      for(index; index < this.invite-1 ;index++){
        this.registerForm.setControl("invite-lastname-"+index,this.registerForm.controls["invite-lastname-"+(index+1)])
        this.registerForm.setControl("invite-firstname-"+index,this.registerForm.controls["invite-firstname-"+(index+1)])
        this.registerForm.setControl("invite-email-"+index,this.registerForm.controls["invite-email-"+(index+1)])
        this.registerForm.setControl("invite-phone-"+index,this.registerForm.controls["invite-phone-"+(index+1)])
      }
      this.invite = (this.invite > 0) ? --this.invite : 0;
      this.removeInviteControl(this.invite);
    }
  }

  private removeInviteControl(index: number) {
    this.registerForm.removeControl("invite-lastname-" + index);
    this.registerForm.removeControl("invite-firstname-" + index);
    this.registerForm.removeControl("invite-email-" + index);
    this.registerForm.removeControl("invite-phone-" + index);
  }

  inviteValide(formControlName: string):boolean{
    let formControl = this.registerForm.controls[formControlName];
    return (formControl) ? (formControl.touched && formControl.invalid) : false;
  }

  inviteValideOne(formControlName: string, erreurName:string): boolean {
    let formControl = this.registerForm.controls[formControlName];
    return (formControl) ? formControl.errors[erreurName] : false;
  }

}



// WEBPACK FOOTER //
// ./src/app/screens/register/register.component.ts